import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, InputSignal, Signal, ChangeDetectionStrategy } from '@angular/core';
import { AlertComponent } from '@components/atoms/alert/alert.component';
import { CardMode } from '@components/card/card.component';
import {
    CarRentalPreferencesComponent,
    RentalCarPreferencesFormGroup,
} from '@components/molecules/forms/patient-travel-card/car-rental-preferences/car-rental-preferences.component';
import { MdsDividerComponent, MdsExpansionPanelComponent } from '@medpacesoftwaredevelopment/designsystem';
import { TravelRequest } from '@models/request';
import { Study } from '@models/study';
import { RequestStateService } from '@services/state-management/request-state.service';
import { TravelViewModelService } from '@services/travel-view-model/travel-view-model.service';
import { getAlertContent } from '@utility/utility.travel-request';
import { map } from 'rxjs';
import { RentalCarRequestDetailsFormGroup } from '../../form-groups/detail-form-groups/travel/rental-car-request.formgroup';
import { NeedsTravelFormGroup, TravelFormGroup } from '../../form-groups/travel-request-card.formgroup';
import { NeedsTravelRadioGroupComponent } from '../../needs-travel-radio-group/needs-travel-radio-group.component';
import { CarRentalRequestDetailsEditComponent } from './car-rental-request-details/edit/car-rental-request-details-edit.component';
import { CarRentalRequestDetailsViewComponent } from './car-rental-request-details/view/car-rental-request-details-view.component';

@Component({
    selector: 'medpace-rental-car-travel-request-tab',
    imports: [
        CommonModule,
        AlertComponent,
        MdsDividerComponent,
        NeedsTravelRadioGroupComponent,
        CarRentalRequestDetailsEditComponent,
        CarRentalRequestDetailsViewComponent,
        MdsExpansionPanelComponent,
        CarRentalPreferencesComponent,
    ],
    templateUrl: './rental-car-travel-request-tab.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './rental-car-travel-request-tab.component.scss',
})
export class RentalCarTravelRequestTabComponent {
    private readonly requestStateService = inject(RequestStateService);
    private readonly travelViewModelService = inject(TravelViewModelService);

    public readonly mode: InputSignal<CardMode> = input.required();
    public readonly study: InputSignal<Study> = input.required();
    public readonly formGroup: InputSignal<
        NeedsTravelFormGroup<TravelFormGroup<RentalCarPreferencesFormGroup, RentalCarRequestDetailsFormGroup>>
    > = input.required();

    public readonly isRentalCarAvailable: Signal<boolean> = computed(
        () => !!this.study().studyInfo?.studyTravelOptions.find((o) => o.name === 'Rental Cars')
    );
    public readonly isUpdate = computed(() => !!this.travelViewModelService.travelCardViewModel()?.isUpdate);

    public readonly isRentalCarRequested$ = this.requestStateService.travelRequestStateService
        .getState()
        .pipe(map((travelRequest: TravelRequest) => travelRequest?.rentalCarRequired));

    public readonly nonAvailableMessage: string = getAlertContent('rental car');
}
